import React, { useEffect, useState } from "react";
import "./VirasatV2GalleryPage.scss"
import { sortByOrderAscending } from "../../helper/helper";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import Carousel2 from "../../components/Carousel/Carousel2";
import Button from "../../components/Button/Button";
import image1 from "../../assets/gal1.jpg"
import image2 from "../../assets/gal2.jpg"
import image3 from "../../assets/gal3.jpg"

const VirasatV2GalleryPage = () => {
    const [showAll, setShowAll] = useState(false)
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "gallery")
    const Components = page?.Components || []
    const history = useHistory()
    useEffect(() => {
        window.scrollTo(0, 0);
        if (Components.length === 0) {
            history.push("/")
        }
    }, []);
    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatGalleryPage-hero-header":
                return <div className="VirasatV2GalleryPage-hero-header-cont">
                    <div className="VirasatV2GalleryPage-hero-header">{component?.Props?.header}</div>
                    <div className="VirasatV2GalleryPage-hero-subheader">{component?.Props?.subheader}</div>
                </div>
            default:
                return <div />
        }

    }
    const headerComponent = (headerComponents) => {
        return (
            <div className="VirasatV2GalleryPage-hero" style={{
                backgroundImage: `linear-gradient(0deg, rgba(22, 65, 106, 0.4), rgba(22, 65, 106, 0.4)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)), url(${headerComponents?.Props?.bgSrc})`
            }}>
                <div className="VirasatV2GalleryPage-hero-container">
                    <div className="VirasatV2GalleryPage-hero-container-wrapper">
                        {sortByOrderAscending(headerComponents?.Components).map((component, key) => {
                            return (<div key={key}>
                                {getHeaderComponents(component)}
                            </div>)
                        })}

                    </div>
                </div>
            </div>
        )
    }
    const getcontentComponents = (component) => {
        switch (component.ID) {
            case "VirasatGalleryPage-images-carousel":
                return <div className="VirasatV2GalleryPage-wrapper-container-img"><Carousel2 images={component?.Data} /></div>

            default:
                return <div />
        }

    }
    const getcontentComponents2 = (component) => {

        switch (component.ID) {
            case "VirasatGalleryPage-header":
                return <div className="VirasatV2GalleryPage-wrapper-container-cont-header">{component?.Props?.text}</div>
            case "VirasatGalleryPage-subheader":
                return <div className="VirasatV2GalleryPage-wrapper-container-cont-subheader">{component?.Props?.text}</div>
            case "VirasatGalleryPage-images-grid":
                return <>
                    <div className="VirasatV2GalleryPage-wrapper-container-cont-grid">
                        {component?.Data?.slice(0, showAll ? component?.Data?.length : 6).map((image, key) => {
                            return (
                                <img alt="" key={key} src={image?.src} />
                            )
                        })} </div>
                    <div className="VirasatV2GalleryPage-wrapper-container-cont-btncont">
                        {component?.Data?.length > 6 ? <Button
                            text={!showAll ? component?.Props?.btnText : component?.Props?.hideBtnText}
                            width={"max-content"}
                            onClick={() => setShowAll((prev) => !prev)} /> : null}
                    </div>
                </>
            default:
                return <div />
        }

    }

    const containerComponent = (containerComponents) => {
        return (
            <div className="VirasatV2GalleryPage-wrapper">
                <div className="VirasatV2GalleryPage-wrapper-container">
                    {sortByOrderAscending(containerComponents).map((component, key) => {
                        return (
                            getcontentComponents(component)
                        )
                    })}
                </div >
                <div className="VirasatV2GalleryPage-wrapper-container-cont">
                    {sortByOrderAscending(containerComponents).map((component, key) => {
                        return (
                            getcontentComponents2(component)
                        )
                    })}
                </div>
            </div>

        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatGalleryPage-hero":
                return headerComponent(component)
            case "VirasatGalleryPage-container":
                return containerComponent(component?.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatV2GalleryPage" >
            {sortByOrderAscending(Components).map((component, key) => {
                return (getComponents(component))
            })}

        </div >
    )
}
export default VirasatV2GalleryPage      